import React from 'react';
import { LOGO_URL, UpsellOption, getCheckoutUrl } from '../data/copy';
import { trackPackAddToCart } from '../utils/metaPixel';
export function TopBar({
  selectedUpsell
}: {
  selectedUpsell: UpsellOption;
}) {
  return <div className="sticky top-0 z-40 w-full border-b border-bone/10 bg-abyss/90 backdrop-blur" data-id="element-178" data-mp="1y4vdcz25yph2">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between gap-3 px-4 sm:h-16 sm:px-8" data-id="element-179" data-mp="1t5r5qcuw0zsu">
        <div className="flex min-w-0 items-center gap-2.5" data-id="element-180" data-mp="2qr6fwf9bz0gi">
          <img src={LOGO_URL} alt="Charly Baits" className="h-9 w-9 shrink-0 rounded-full object-cover object-left ring-1 ring-chartreuse/40 sm:h-10 sm:w-10" data-id="element-181" data-mp="2ltmxd35lo1ir" />
          <span className="truncate font-display text-lg uppercase leading-none tracking-wide text-bone sm:text-xl" data-id="element-182" data-mp="2c43is9ox6ttp">
            Charly Baits
          </span>
        </div>
        <a href="#pack" className="shrink-0 bg-chartreuse px-3.5 py-2 font-cond text-sm uppercase leading-none tracking-wide text-abyss transition-colors hover:bg-[#d8ff3d] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-chartreuse/60 sm:px-5 sm:py-2.5 sm:text-base" data-id="element-183" data-mp="39kscfg3pups0">
          Comprar ${selectedUpsell.price}
        </a>
      </div>
    </div>;
}